
<div class=" mt-4">

    <div class=" mb-3">
      <div class="flex items-center  px-4 py-2   font-bold mb-5 align-middle m-auto">
        <mat-icon class="mat-18 text-5xl w-10 h-8 text-primary-500 dark:text-white" >notifications_on</mat-icon>
        <p class="ml-3 text-2xl text-primary-500 dark:text-white mt-2">Alerts List</p>
      </div>
    </div>


    <div class="overflow-x-auto">
      <div class="flex flex-col items-center h-fit w-full relative" >
        <app-shared-table class="w-full" [tableData]="dataSource" [tableColumns]="displayedColumns" [totalItems]="totalItems"
          (sortEvent)="changedSort($event)" (actionRowEvent)="rowSelect($event)" (pageChangedEvent)="changedPage($event)"
          (filtersChangedEvent)="onChangeFilter($event)" (actionEmittedEvent)="actionOnTable($event)">
        </app-shared-table>


      </div>
      @if(!(totalItems > 0)){
        @if(loadingTable()){
          <div *ngFor="let _ of [].constructor(10)" class="flex space-x-4 py-1">
            <div class="h-8 w-full bg-gray-400 rounded animate-pulse"></div>
          </div>
          }
      }
    </div>
  </div>
